export async function fetchAPI(query, { variables } = {}) {
	const headers = { 'Content-Type': 'application/json' };

	console.log({ url: import.meta.env.VITE_API_URL });
	const res = await fetch(
		import.meta.env.VITE_API_URL ?? 'http://norsk-fisk.local/graphql',
		{
			method: 'POST',
			headers,
			body: JSON.stringify({
				query,
				variables
			})
		}
	);

	const json = await res.json();
	if (json.errors) {
		console.error(json.errors);
		throw new Error('Failed to fetch API');
	}
	return json.data;
}

function hasItems(array) {
	return array?.length >= 1;
}

export async function getEncyclopediaResults(
	filters = {},
	freeTextSearch = '',
	after = null,
	before = null
) {
	const {
		ordering,
		industryTerms,
		specieTerms,
		countyTerms,
		types,
		favorites
	} = filters;

	const [orderby, order] = ordering.split('-');

	const typesSlugs = types?.map(i => i.slug);
	const industryTermsSlugs = industryTerms?.map(i => i.slug);
	const specieTermsSlugs = specieTerms?.map(i => i.slug);
	const countyTermsSlugs = countyTerms?.map(i => i.slug);

	// Turn slugs into content types
	const contentTypes =
		typesSlugs.length > 0
			? typesSlugs.map(item => {
					if (item == 'actor' || item == 'organization')
						return 'AKTORER';
					if (item == 'person') return 'PERSONER';
				})
			: ['AKTORER', 'PERSONER'];

	const query = `
	query EncyclopedaResults (
		$freeTextSearch: String,
		$orderby: PostObjectsConnectionOrderbyEnum!,
		$order: OrderEnum!,
		$contentTypes: [ContentTypeEnum],
		${hasItems(industryTermsSlugs) ? `$industryTermsSlugs: [String],` : ``}
		${hasItems(specieTermsSlugs) ? `$specieTermsSlugs: [String],` : ``}
		${hasItems(countyTermsSlugs) ? `$countyTermsSlugs: [String],` : ``}
		${favorites ? `$favorites: [ID],` : ``}
		${after ? '$after: String,' : ''}
		${before ? '$before: String,' : ''}
	) {
		contentNodes(
			first: 36, 
			${after ? 'after: $after,' : ''}
			${before ? 'before: $before,' : ''}
			where: {
				contentTypes: $contentTypes,
				${favorites ? `in: $favorites,` : ``}
				search: $freeTextSearch,
				orderby: {
					field: $orderby,
					order: $order
				},
				${
					hasItems(industryTermsSlugs) ||
					hasItems(specieTermsSlugs) ||
					hasItems(countyTermsSlugs) ||
					hasItems(typesSlugs) ||
					typesSlugs.includes('organization')
						? `
						taxQuery: {
							relation: AND,
							taxArray: [
							${
								typesSlugs.includes('organization') &&
								!typesSlugs.includes('actor')
									? `
									{
										operator: IN,
										field: SLUG,
										terms: "organisasjoner",
										taxonomy: ACTORTYPE
									},
							`
									: ``
							}
							${
								typesSlugs.includes('actor') &&
								!typesSlugs.includes('organization')
									? `
									{
										operator: NOT_IN,
										field: SLUG,
										terms: "organisasjoner",
										taxonomy: ACTORTYPE
									},
							`
									: ``
							}
							${
								hasItems(industryTermsSlugs)
									? `
									{
										operator: AND,
										field: SLUG,
										terms: $industryTermsSlugs,
										taxonomy: INDUSTRY
									},
							`
									: ``
							}
							
							${
								hasItems(specieTermsSlugs)
									? `
									{
										operator: AND,
										field: SLUG,
										terms: $specieTermsSlugs,
										taxonomy: SPECIE
									},
							`
									: ``
							}
							
							${
								hasItems(countyTermsSlugs)
									? `
									{
										operator: AND,
										field: SLUG,
										terms: $countyTermsSlugs,
										taxonomy: COUNTY
									},
							`
									: ``
							}
							]
						}`
						: ``
				}
			}) {
				pageInfo {
					endCursor
					hasNextPage
					hasPreviousPage
					startCursor
				}
				nodes {
					databaseId
					link
					contentType {
						node {
							labels {
								singularName
							}
							graphqlSingleName
						}
					}
					... on Actor {
						id
						title
						
						counties {
							nodes {
								name
							}
						}
						actorTypes {
							nodes {
								name
							}
						}
						species {
							nodes {
								name
							}
						}
						industries {
							nodes {
								name
							}
						}
						actorFields {
							email
							phone
							logoImage {
								node {
									altText
									sourceUrl
								}
							}
						}
					}
					... on Person {
						id
						title
						personFields {
							mobileNumber
							workEmail
							profileImage {
								node {
									altText
									sourceUrl
								}
							}
							specialPosition
						}
						species {
							nodes {
								name
							}
						}
						industries {
							nodes {
								name
							}
						}
					}
				}
			}
	  }
	`;

	const params = {
		variables: {
			freeTextSearch: freeTextSearch ?? null,
			orderby: orderby ?? null,
			order: order ?? null,
			industryTermsSlugs: industryTermsSlugs ?? null,
			specieTermsSlugs: specieTermsSlugs ?? null,
			countyTermsSlugs: countyTermsSlugs ?? null,
			favorites: favorites ?? null,
			after: after ?? null,
			before: before ?? null,
			contentTypes: contentTypes ?? null
		}
	};

	const data = await fetchAPI(query, params);
	console.log(data);

	return [data.contentNodes.nodes, data.contentNodes.pageInfo];
}

export async function getFilters(searchIndustries) {
	const data = await fetchAPI(
		`
    query Filters ($searchIndustries: String) {
      industries(where: {nameLike: $searchIndustries}, first: 100) {
				nodes {
					name
					slug
					parentId
					industriesCustom{
						hidden
					}
					children(first: 100) {
						nodes {
							name
							slug
						}
					}
				}
			}
			counties(first: 20) {
				nodes {
					name
					slug
					parentId
				}
			}
			species(first: 100) {
				nodes {
					name
					slug
					parentId
					children(first: 100) {
						nodes {
							name
							slug
						}
					}
				}
			}
    }
  `,
		{
			variables: {
				searchIndustries: searchIndustries
			}
		}
	);

	return data;
}
